import * as React from 'react'
import type {
  FilterPanelCheckItem,
} from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'

interface Props {
  items: Array<FilterPanelCheckItem>
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  selectedItems: Set<string>
}

function FlightSingleFilterStops(props: Props) {
  const { items, onFilterChange, selectedItems } = props

  return (
    <FilterPanelCheckboxGroup
      name="stops"
      items={items}
      onChange={onFilterChange}
      selected={selectedItems}
      maxItems={5}
      density="compact"
      highlightLowestPrice
    />
  )
}

export default FlightSingleFilterStops
